import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from './ui/button';

export const JobsPager = ({ page, pageSize, total, onPage }) => {
  const pages = Math.max(1, Math.ceil(total / pageSize));
  if (total <= pageSize) return null;
  const from = (page - 1) * pageSize + 1;
  return (
    <div className="flex items-center justify-between pt-2" data-testid="jobs-pager">
      <p className="text-xs text-muted-foreground" data-testid="jobs-pager-range">
        Showing {from.toLocaleString()}–{Math.min(page * pageSize, total).toLocaleString()} of {total.toLocaleString()} jobs
      </p>
      <div className="flex items-center gap-1.5">
        <Button variant="outline" size="sm" className="h-8 gap-1" disabled={page <= 1} onClick={() => onPage(page - 1)} data-testid="jobs-pager-prev">
          <ChevronLeft className="h-3.5 w-3.5" /> Prev
        </Button>
        <span className="text-xs tabular-nums px-2" data-testid="jobs-pager-page">Page {page} of {pages}</span>
        <Button variant="outline" size="sm" className="h-8 gap-1" disabled={page >= pages} onClick={() => onPage(page + 1)} data-testid="jobs-pager-next">
          Next <ChevronRight className="h-3.5 w-3.5" />
        </Button>
      </div>
    </div>
  );
};

export default JobsPager;
